import React from 'react';
import { useUserContext } from '../../context/user';
import { Navigate } from "react-router-dom";
import { ModeratorPermissionsResponse } from '../../types/api/moderators';
import { UserRole, isAdminRole } from '../../types/common/permissions';
import AccessDeniedLayout from '../../layouts/AccessDeniedLayout';
import AdminPageLayout from '../../layouts/AdminPageLayout';
import { useSignOut } from "../../hooks/useSignOut";

interface ProtectedRouteProps {
    allowedRoles: UserRole[];
    requiredPermissions: (keyof ModeratorPermissionsResponse)[];
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    allowedRoles,
    requiredPermissions = [],
    children
}) => {
    const { jwtToken, profile } = useUserContext();
    const signOut = useSignOut();

    // Проверка аутентификации
    if (!jwtToken) {
        return <Navigate to="/sign_in/refresh_token" replace />;
    }

    const { role, permissions } = profile || {};

    // Проверка наличия роли
    if (!role) {
        return <AccessDeniedLayout message="Доступ для вашей роли запрещён" onSignOut={signOut} />;
    }

    // Проверка разрешенных ролей
    if (!allowedRoles.includes(role)) {
        console.error('ProtectedRoute Error: role not allowed');
        return <AccessDeniedLayout message="Доступ для вашей роли запрещён" onSignOut={signOut} />;
    }

    const isAdmin = isAdminRole(role);
    const hasRequiredPermissions = !requiredPermissions.length ||
        (permissions && requiredPermissions.every(perm => permissions[perm]));

    // Проверка разрешений
    if (!isAdmin && !hasRequiredPermissions) {
        console.error('ProtectedRoute Error: insufficient permissions');
        return <AccessDeniedLayout message="Недостаточно прав доступа" onSignOut={signOut} />;
    }

    return <AdminPageLayout>{children}</AdminPageLayout>;
};

export default ProtectedRoute;